var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkAreaVerticalSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_134_4007",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.538086,
    y: 0.676758,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_134_4007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5381 21.6768C14.9881 21.6768 14.5174 21.4811 14.1261 21.0898C13.7341 20.6978 13.5381 20.2268 13.5381 19.6768V5.67676C13.5381 5.12676 13.7341 4.65576 14.1261 4.26376C14.5174 3.87242 14.9881 3.67676 15.5381 3.67676H19.5381C20.0881 3.67676 20.5591 3.87242 20.9511 4.26376C21.3424 4.65576 21.5381 5.12676 21.5381 5.67676V19.6768C21.5381 20.2268 21.3424 20.6978 20.9511 21.0898C20.5591 21.4811 20.0881 21.6768 19.5381 21.6768H15.5381ZM5.53809 21.6768C4.98809 21.6768 4.51709 21.4811 4.12509 21.0898C3.73375 20.6978 3.53809 20.2268 3.53809 19.6768V5.67676C3.53809 5.12676 3.73375 4.65576 4.12509 4.26376C4.51709 3.87242 4.98809 3.67676 5.53809 3.67676H9.53809C10.0881 3.67676 10.5591 3.87242 10.9511 4.26376C11.3424 4.65576 11.5381 5.12676 11.5381 5.67676V19.6768C11.5381 20.2268 11.3424 20.6978 10.9511 21.0898C10.5591 21.4811 10.0881 21.6768 9.53809 21.6768H5.53809Z",
    fill: "#4267F4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkAreaVerticalSelected);
export default __webpack_public_path__ + "static/media/bookmark_area_vertical_selected.0de52edc842089a5fcf31f88012602ef.svg";
export { ForwardRef as ReactComponent };